/**
 * Copyright (c) 2020
 *
 * @summary calls to customersManager/customer
 * @author Julien <julien.donnadieu@yooda.com>
 *
 * Created at     : 2020-06-08 10:21:56
 * Last modified  : 2020-06-26 15:31:17
 */

import axios from '@/api/axios.js'

export default {

    /**
     * @param email String
     * @param fullFetchMode Boolean
     * @returns Promise
     */
    readCustomerByEmail (email, fullFetchMode = true) {
        return axios.get(`/customers-manager/customers/${email}`, {
            params: {
                'full-fetch-mode': fullFetchMode
            }
        })
    },

    /**
     * @param subscriptionId integer
     * @param token
     * @returns Promise
     */
    refreshAnalyticsToken (subscriptionId, token) {
        return axios.put(`/configuration/subscription-metas/${subscriptionId}`, token)
    },





};
